import axios from 'axios'; // 引入axios
import global from '../config/global'; // 引入配置文件
import { Loading } from 'element-ui';
import { Message } from 'element-ui';
axios.defaults.timeout = global.serverTimeout; // 配置请求超时时间
axios.defaults.baseURL = global.baseUrl;
axios.defaults.headers = []

// request模型
var requestHandler = {
    url: null, //请求地址
    params: {}, //请求参数
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(requestHandler, showLoading) {
    return new Promise((resolve, reject) => {
        let _this = this;
        let loadingInstance = null;
        if (showLoading)
            loadingInstance = Loading.service({
                lock: true,
                text: '请稍后...',
                spinner: 'el-icon-loading'
            });
        axios({
                method: 'get',
                url: requestHandler.url,
                data: requestHandler.params,
                headers: {
                    'token': localStorage.getItem("token"),
                }
            }).then(response => {
                if (showLoading)
                    loadingInstance.close();
                var res = response.data;
                console.log("response:", res);
                if (res.success)
                    resolve(res.data);
                else {
                    Message.closeAll();
                    Message.error(res.message)
                    if (res.code == 204) { //身份失效
                        localStorage.setItem("token", "");
                        _this.$router.push("/login")
                    }
                }
            })
            .catch(err => {
                if (showLoading)
                    loadingInstance.close();
                console.log("err:", err);
                Message.closeAll();
                Message.error("网络异常")
                reject(err)
            })
    })
}

/**
 * 封装Post方法
 * @returns {Promise}
 */
export function post(requestHandler, showLoading) {
    return new Promise((resolve, reject) => {
        let _this = this;
        let loadingInstance;
        if (showLoading)
            loadingInstance = Loading.service({
                lock: true,
                text: '请稍后...',
                spinner: 'el-icon-loading'
            });
        axios({
            method: 'post',
            url: requestHandler.url,
            data: requestHandler.params,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'token': localStorage.getItem("token"),
            }
        }).then(function(response) {
            if (showLoading)
                loadingInstance.close();
            var res = response.data;
            console.log("response:", res);
            if (res.success) { //成功
                resolve(res.data);
            } else { //出错
                Message.closeAll();
                Message.error(res.message);
                reject(res);
                if (res.code == 204) { //身份失效
                    localStorage.setItem("token", "");
                    _this.$router.push("/login")
                }
            }
        }).catch(err => {
            if (showLoading)
                loadingInstance.close();
            console.log("err:", err);
            Message.closeAll();
            Message.error("网络异常")
            reject(err)
        })
    })
}

/**
 * 文件上传
 * @param {*} url 
 * @param {*} data 
 * @param {*} showLoading 
 */
export function upload(url, data, showLoading) {
    return new Promise((resolve, reject) => {
        let _this = this;
        let loadingInstance;
        if (showLoading)
            loadingInstance = Loading.service({
                lock: true,
                text: '请稍后...',
                spinner: 'el-icon-loading'
            });
        var param = new FormData();
        param.append("file", data);
        axios({
            method: 'post',
            url: url,
            data: param,
            headers: {
                'Content-Type': 'multipart/form-data',
                'token': localStorage.getItem("token"),
            }
        }).then(function(response) {
            if (showLoading)
                loadingInstance.close();
            var res = response.data;
            console.log("response:", res);
            if (res.success) { //成功
                resolve(res.data);
            } else { //出错
                Message.closeAll();
                Message.error(res.message)
                if (res.code == 204) { //身份失效
                    localStorage.setItem("token", "");
                    _this.$router.push("/login")
                }
            }
        }).catch(err => {
            if (showLoading)
                loadingInstance.close();
            console.log("err:", err);
            Message.closeAll();
            Message.error("网络异常")
            reject(err)
        })
    })
}